import React from 'react';
import { styled } from '@mui/material/styles';
import { Container, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCalendarDay,
    faClock,
    faLocationDot,
    faUtensils,
} from '@fortawesome/free-solid-svg-icons';
import SectionTitle from '../../../../components/SectionTitle';

const IntroductionRoot = styled('div')(({ theme }) => ({
    backgroundColor: '#F8F9FA',
    padding: '50px 0',
    textAlign: 'center',
}));

const EventDetails = styled('div')(({ theme }) => ({
    margin: '40px auto 0',
    maxWidth: '600px',
    padding: '32px 40px',
    textAlign: 'left',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E0E0E0',
    borderTop: '4px solid #D7412E',
    borderRadius: '4px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
    [theme.breakpoints.down('sm')]: {
        padding: '24px',
    },
}));

const EventDetailsTitle = styled(Typography)(({ theme }) => ({
    marginBottom: '8px',
    textAlign: 'center',
}));

const DetailRow = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '14px 0',
    borderBottom: '1px solid #F0F0F0',
    '&:last-of-type': {
        borderBottom: 'none',
        paddingBottom: 0,
    },
}));

const DetailIcon = styled('span')(({ theme }) => ({
    flex: '0 0 36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: 'rgba(215, 65, 46, 0.1)',
    color: '#D7412E',
    fontSize: '16px',
}));

const DetailLabel = styled(Typography)(({ theme }) => ({
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: '#666666',
}));

const Detail = (props) => {
    const { icon, label, value } = props;

    return (
        <DetailRow>
            <DetailIcon>
                <FontAwesomeIcon icon={icon} />
            </DetailIcon>
            <div>
                <DetailLabel variant="body2">{label}</DetailLabel>
                <Typography variant="body1">{value}</Typography>
            </div>
        </DetailRow>
    );
};

const Introduction = () => {
    return (
        <IntroductionRoot>
            <Container maxWidth="lg">
                <SectionTitle
                    title="Broker and Managing Agent Event"
                    subtitle="Let's Talk Liability"
                    hideArrow={true}
                />

                <Typography variant="body1" marginY={2}>
                    Join us for an insightful morning as we unpack liability in community schemes.
                    Complete the form below to reserve your seat.
                </Typography>

                <EventDetails>
                    <EventDetailsTitle variant="h5">Event Details</EventDetailsTitle>

                    <Detail icon={faCalendarDay} label="Date" value="11 November 2026" />
                    <Detail icon={faClock} label="Time" value="08:30 for 09:00" />
                    <Detail
                        icon={faLocationDot}
                        label="Venue"
                        value="Serengeti Golf Estate Conference Venue"
                    />
                    <Detail
                        icon={faUtensils}
                        label="Catering"
                        value="Complimentary breakfast included"
                    />
                </EventDetails>
            </Container>
        </IntroductionRoot>
    );
};

export default Introduction;
